<template>
  <div class="cmsnotice" :class="{ isiOSX: isiOSX }">
    <van-nav-bar
      class="cmsnotice-title"
      :fixed="true"
      title="销巴公告"
      right-text="全部已读"
      @click-right="allRead"
    />
    <img
      @click="goBack()"
      class="cmsnotice-reback"
      src="../../../assets/myInvest/reback.png"
    />
    <div class="cmsnotice-content">
      <div id="list-content">
        <div class="loading" v-if="!isLoadingEnd">
          <img src="./../../../assets/takingCar/loading.gif" alt="" />
        </div>
        <div v-if="isLoadingEnd">
          <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
            v-if="list.length > 0"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <van-cell v-for="(item, index) in list" :key="index">
                <div class="listOut">
                  <p class="time">{{ item.date | timeFormatting }}</p>
                  <div
                    class="listItem"
                    v-for="(i, j) in item.dataList"
                    :key="j"
                    @click="goToSeeDetail(i.id)"
                  >
                    <div class="content">
                      <div class="left">
                        <p class="title" :class="{ readTitle: i.is_read }">
                          {{ i.title }}
                        </p>
                        <p class="tip" :class="{ readTip: i.is_read }">
                          {{ i.content | contentText }}
                        </p>
                      </div>
                      <div class="right">
                        <div class="img">
                          <van-image
                            width="76px"
                            height="76px"
                            fit="cover"
                            :src="i.image"
                          >
                          <template v-slot:error>
                            <img src="../../../assets/cms/notice.png" alt="" srcset="">
                          </template>
                          </van-image>
                        </div>
                        <div v-if="i.is_read" class="isRead"></div>
                        <img
                          src="../../../assets/cms/overdue.png"
                          class="isEnd"
                          v-if="i.is_end"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </van-cell>
            </van-list>
          </van-pull-refresh>
          <van-row class="empty" v-if="list.length == 0">
            <van-col class="emptyMsg" span="24">
              <img src="../../../assets/member/nomessage.png" />
              <p class="tip1">暂无公告消息</p>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isiOSX: false,
      isLoadingEnd: false,
      //   下拉刷新
      isLoading: false, //加载中
      loading: false,
      finished: true,
      page: 1, //请求第几页
      total: 0, //总共的数据条数
      size: 10,
      list: [],
      isLoad: true,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(this.$route.query.token);
    this.getDate();
  },
  filters: {
    contentText(value) {
      let result = "";
      let flag = false;
      for (let char of value) {
        if (char === ">") {
          flag = true;
        }
        if (char === "<") {
          flag = false;
        }
        if (flag && char !== ">") {
          result = result.replace(/&nbsp;/g, "") + char.replace(/&nbsp;/g, "");
        }
      }
      return result;
    },
    timeFormatting(value) {
      return value.replace(/-/g, ".");
    },
  },
  methods: {
    // 加载更多
    onLoad() {
      this.page++;
      this.getDate();
    },
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.finished = true;
      this.isLoadingEnd = false;
      this.list = [];
      this.getDate();
    },
    getDate() {
      this.$api
        .get("/cms-v2/member/notice/list", {
          page: this.page,
          size: this.size,
          client: 1,
        })
        .then((res) => {
          this.list = this.list.concat(res.data);
          this.isLoadingEnd = true;
          this.loading = false;
          if (this.list.length >= res.total) {
            // 数据全部加载完成
            this.finished = true;
          } else {
            this.finished = false;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        });
    },
    goBack() {
      this.params("", "", "goBack");
    },
    allRead() {
      this.$api
        .post("/cms-v2/member/notice/all/read", {
          client: 1,
        })
        .then((res) => {
          this.list.forEach((item) => {
            item.dataList.forEach((i) => {
              i.is_read = true;
            });
          });
        });
    },
    // 查看详情
    goToSeeDetail(id) {
      this.$router.push({
        path: "/cms-notice/detail",
        query: {
          id: id,
          token: this.$route.query.token,
          entranceChannel: 1,
          isApp: 1,
        },
      });
    },
  },
  mounted() {
    let winHeight = document.documentElement.clientHeight; //视口大小
    document.getElementById("list-content").style.height =
      winHeight - 100 + "px"; //调整上拉加载框高度
  },
};
</script>

<style lang="less">
body {
  min-height: 100%;
  background: #f5f6f7;
  height: auto;

  .van-nav-bar__title{
    font-size: 18px !important;
    font-weight: normal !important;
  }
  .cmsnotice {
    height: 100%;
    &-title {
      height: 44px;
      line-height: 44px;
      padding-top: 24px;
      box-shadow: 0 1px 0 #eee;
      .van-nav-bar__title {
        color: #333;
        font-size: 17px;
        font-weight: 700;
      }
      .van-nav-bar__text {
        color: #333;
      }
    }
    &-reback {
      width: 15px;
      padding: 12px 15px;
      position: fixed;
      top: 27px;
      left: 0;
      z-index: 1;
    }
    &-content {
      background: #f5f6f7;
      padding: 16px;
      padding-top: 68px;
      box-sizing: border-box;
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      .loading {
        text-align: center;
        margin-top: 132px;
        img {
          width: 100px;
        }
      }
      .van-cell {
        background: #f5f6f7;
        padding: 0;
        .listOut {
          .time {
            text-align: center;
            margin-top: 16px;
            color: #999999;
            font-size: 12px;
            line-height: 12px;
          }
          .listItem {
            margin-top: 12px;
            position: relative;
            .content {
              background-color: #ffffff;
              padding: 18px 12px;
              border-radius: 8px;
              display: flex;
              margin-top: 10px;
              .left {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .title {
                  font-size: 17px;
                  font-weight: bolder;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                }
                .readTitle {
                  color: rgba(51, 51, 51, 0.5);
                }
                .tip {
                  font-weight: bolder;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  color: #999999;
                  font-weight: normal;
                  word-break: break-word;
                  font-size: 14px;
                }
                .readTip {
                  color: rgba(153, 153, 153, 0.5);
                }
              }
              .right {
                width: 76px;
                height: 76px;
                position: relative;
                margin-left: 11px;
                .img {
                  overflow: hidden;
                  width: 76px;
                  height: 76px;
                  position: relative;
                  border-radius: 4px;
                  img {
                    width: 76px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                    border-radius: 4px;
                  }
                }
                .isRead {
                  width: 76px;
                  height: 76px;
                  position: absolute;
                  border-radius: 4px;
                  top: 0;
                  left: 0;
                  background-color: rgba(255, 255, 255, 0.5);
                }
                .isEnd {
                  width: 48px;
                  height: 48px;
                  position: absolute;
                  right: -8px;
                  top: -12px;
                }
              }
            }
          }
        }
      }
      .van-cell::after {
        border: none;
      }
      .empty {
        padding-top: 132px;
        text-align: center;
        img {
          width: 100%;
        }
        .tip1 {
          color: #333;
          font-size: 13px;
          margin-top: 40px;
          height: 26px;
          line-height: 26px;
        }
      }
    }
  }
  .isiOSX {
    .cmsnotice {
      &-title {
        padding-top: 44px;
      }
      &-reback {
        top: 45px;
      }
      &-content {
        padding-top: 98px;
      }
    }
  }
}
</style>
